import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as queryString from 'query-string';
import * as clubActions from '../../actions/club-actions';

import requireAuth from '../../components/hocs/requireAuth';
import Splash from '../../components/Splash';
import EventCreateForm from './EventCreateForm';
import EventCreateTemplates from './EventCreateTemplates';
import EventCreateChooseSport from './EventCreateChooseSport';

import { useStatsig } from '../../components/hooks/useStatsig';
import { checkIfStatsigUpdateIsNeeded } from '../../utils/events';

function EventCreatePage(props) {
    const { location } = props;
    const { step, sportTypeId } = queryString.parse(location.search);

    const club = useSelector(({ club }) => club);
    const dispatch = useDispatch();

    const [showCreateForm, setShowCreateForm] = useState(!!step);
    const [templateId, setTemplateId] = useState(null);
    const [clubIdInUrl, setClubIdInUrl] = useState();
    const [clubId, setClubId] = useState();
    const [isDemoEvent, setIsDemoEvent] = useState();

    const { updateStatsigUser, statsigUser } = useStatsig();

    useEffect(() => {
        const { clubId, demoEvent, templateId } = queryString.parse(location.search);
        if (clubId) {
            setClubIdInUrl(true);
            setClubId(clubId);
            setIsDemoEvent(!!demoEvent);
            setTemplateId(templateId);
            if (templateId) {
                setShowCreateForm(true);
            }
            if (parseInt(clubId) !== club?.clubDetails?.id) {
                dispatch(clubActions.setClubId(clubId));
            }
        } else {
            dispatch(clubActions.getAllClubs());
        }
    }, []);

    // update statsig user when club and sport type id are available
    useEffect(() => {
        if (clubIdInUrl && parseInt(sportTypeId)) {
            const data = { clubId: parseInt(clubId), sportTypeId: parseInt(sportTypeId) };
            const isStatsigUserUpdateNeeded = checkIfStatsigUpdateIsNeeded(data, statsigUser);
            if (isStatsigUserUpdateNeeded) {
                updateStatsigUser({
                    sportTypeId: parseInt(sportTypeId),
                    clubId: parseInt(clubId),
                });
            }
        }
    }, [clubIdInUrl, sportTypeId]);

    const handleToCreateForm = ({ templateId }) => {
        setShowCreateForm(true);
        setTemplateId(templateId);
    };

    if (club.isLoading) {
        return <Splash show title={'Loading'} />;
    }

    if (!sportTypeId) {
        return <EventCreateChooseSport />;
    }

    return (
        showCreateForm ? (
            <EventCreateForm
                {...props}
                clubIdInUrl={clubIdInUrl}
                clubId={clubId}
                isDemoEvent={isDemoEvent}
                templateId={templateId}
            />
        ) : (
            <EventCreateTemplates
                club={club}
                clubIdInUrl={clubIdInUrl}
                handleToCreateForm={handleToCreateForm}
                sportTypeId={parseInt(sportTypeId)}
            />
        )
    );
}

export default requireAuth(EventCreatePage);
